<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid>
        <v-row
            class="flex-child"
        >
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-container fluid>
                        <v-row align="center">
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-text-field
                                    solo
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.user.username')"
                                    v-model="searchData.username"
                                />
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-text-field
                                    solo
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.user.realname')"
                                    v-model="searchData.realname"
                                />
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-text-field
                                    solo
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.user.phone')"
                                    v-model="searchData.phone"
                                />
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-text-field
                                    solo
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.user.email')"
                                    v-model="searchData.email"
                                />
                            </v-col>
                            <!--第二行-->
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <ETDatePicker v-model="searchData.lastLoginTime"
                                              :label="$vuetify.lang.t('$vuetify.custom.user.lastLoginTime')"></ETDatePicker>
                            </v-col>
                            <v-col cols="12" md="1" sm="3" xs="3">
                                <v-select
                                    :items="enableItems"
                                    :label="$vuetify.lang.t('$vuetify.custom.user.enableItems')"
                                    hide-details
                                    solo
                                    v-model="searchData.lenable"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="1" sm="3" xs="3">
                                <v-select
                                    :items="workItems"
                                    :label="$vuetify.lang.t('$vuetify.custom.user.workItems')"
                                    hide-details
                                    solo
                                    v-model="searchData.work"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="7" sm="3" xs="3">
                                <v-row justify="end">
                                    <v-btn v-5="permissionCode.search" color="primary mr-3" @click="initialize" dark large>
                                        <v-icon left>mdi-magnify</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.searchBtn') }}
                                    </v-btn>
                                    <v-btn v-5="permissionCode.add" color="success mr-3" @click="dialog=true" dark large>
                                        <v-icon left>mdi-plus</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.addBtn') }}
                                    </v-btn>
                                    <v-btn v-5="permissionCode.moreDelete" color="error mr-3" dark large @click="deleteBtn">
                                        <v-icon left>mdi-delete</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.deleteBtn') }}
                                    </v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-col>
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="desserts"
                        item-key="id"
                        class="elevation-1"
                        show-select
                        multi-sort
                        :loading="loading"
                        :footer-props="footerProps"
                        :loading-text="loadingText"
                        :options.sync="options"
                        :server-items-length="totalDesserts"
                        @update:options="changeOptions"

                    >
                        <template v-slot:item.actions="{ item }">

                            <v-btn v-5="permissionCode.enable" class="mr-2" :color="isEnable(item).color"
                                   x-small @click="lenable(item)">
                                <v-icon small>
                                    {{ isEnable(item).icon }}
                                </v-icon>
                                {{ isEnable(item).text }}
                            </v-btn>

                            <v-btn v-5="permissionCode.quit" class="mr-2" :color="isWork(item).color"
                                   x-small @click="work(item)">
                                <v-icon small>
                                    {{ isWork(item).icon }}
                                </v-icon>
                                {{ isWork(item).text }}
                            </v-btn>

                            <v-btn v-5="permissionCode.delete" color="normal" x-small @click="deleteItem(item)">
                                <v-icon small>
                                    mdi-delete
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.deleteBtn') }}
                            </v-btn>
                            <v-btn v-5="permissionCode.detail" color="normal" x-small @click="showDetailDialog(item)">
                                <v-icon small>
                                    mdi-account-details
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.detail') }}
                            </v-btn>
                            <v-btn v-5="permissionCode.resetPassword" color="" x-small @click="reset(item)">
                                <v-icon small>
                                    mdi-lock-reset
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.resetPassword') }}
                            </v-btn>
                            <v-btn color="normal" x-small v-5="permissionCode.updatePassword"
                                   @click="modPassword(item)">
                                <v-icon small>
                                    mdi-update
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.modifyPassword') }}
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-sheet>
            </v-col>
            <v-dialog v-model="dialog" persistent max-width="500px">
                <user-add v-model="dialog" @initialize="initialize"></user-add>
            </v-dialog>
            <v-dialog v-model="showDetail" persistent max-width="700px">
                <user-detail v-model="showDetail" :userId="userId" @initialize="initialize"></user-detail>
            </v-dialog>
            <v-dialog v-model="resetPasswordDialog" persistent max-width="500px">
                <user-password
                    v-model="resetPasswordDialog"
                    :updateFlag="updateFlag"
                    :resetFlag="resetFlag"
                    :resetUserName="resetUserName"
                    :checkPassword="checkPassword"
                    :userId="userId"
                    @initialize="initialize"></user-password>
            </v-dialog>
        </v-row>
    </v-container>
</template>
<style></style>
<script>
import Mock from 'mockjs';
import userAdd from './user-add'
import userPassword from './user-password'
import userDetail from './user-detail'
import ETDatePicker from '@/components/datepicker/ETDatePicker'

export default {
    data() {
        return {
            permissionCode:{
                add:'sys:user:add',
                detail:'sys:user:detail',
                delete:'sys:user:delete',
                search:'sys:user:search',
                moreDelete:'sys:user:delete:selective',
                enable:'sys:user:enable',
                quit:'sys:user:quit',
                resetPassword:'sys:user:reset:password',
                updatePassword:'sys:user:update:password',
            },
            showDetail: false,
            dialog: false,
            loading: true,
            loadingText: this.$vuetify.lang.t('$vuetify.custom.dataLoading'),
            selected: [],
            footerProps: {
                showFirstLastPage: true,
                showCurrentPage: true,
                //disableItemsPerPage:true,
            },
            searchData: {
                username: '',
                realname: '',
                phone: '',
                email: '',
                lastLoginTime: [],
                lenable: null,
                work: null
            },
            options: {},
            enableItems: [
                {text: this.$vuetify.lang.t('$vuetify.custom.user.pleaseSelect'), value: ''},
                {text: this.$vuetify.lang.t('$vuetify.custom.enable'), value: '1'},
                {text: this.$vuetify.lang.t('$vuetify.custom.disable'), value: '0'},
            ],
            workItems: [
                {text: this.$vuetify.lang.t('$vuetify.custom.user.pleaseSelect'), value: ''},
                {text: this.$vuetify.lang.t('$vuetify.custom.user.work'), value: '1'},
                {text: this.$vuetify.lang.t('$vuetify.custom.user.notWork'), value: '0'},
            ],
            headers: [
                {
                    text: this.$vuetify.lang.t('$vuetify.custom.user.username'),
                    value: 'username',
                },
                {text: this.$vuetify.lang.t('$vuetify.custom.user.realname'), value: 'realname'},
                {text: this.$vuetify.lang.t('$vuetify.custom.user.phone'), value: 'phone'},
                {text: this.$vuetify.lang.t('$vuetify.custom.user.email'), value: 'email'},
                {text: this.$vuetify.lang.t('$vuetify.custom.user.lastLoginTime'), value: 'lastLoginTime'},
                {text: this.$vuetify.lang.t('$vuetify.custom.creator'), value: 'creator'},
                {text: this.$vuetify.lang.t('$vuetify.custom.createTime'), value: 'createTime'},
                {text: this.$vuetify.lang.t('$vuetify.custom.editor'), value: 'editor'},
                {text: this.$vuetify.lang.t('$vuetify.custom.updateTime'), value: 'updateTime'},
                {text: this.$vuetify.lang.t('$vuetify.custom.actions'), value: 'actions', sortable: false},
            ],
            totalDesserts: 0,
            desserts: [],
            resetUserName: '',//重置的用户名
            resetPasswordDialog: false,
            updateFlag: false,//修改密码
            userId: '',
            checkPassword: false,//用户在输入密码
            resetFlag: false,//重置密码
        }

    },
    methods: {
        //用户详细弹窗
        showDetailDialog(item) {
            console.log(item.id);
            this.showDetail = true;
            this.userId = item.id;
        },
        initialize() {
            this.checkPassword = false;
            this.updateFlag = false;
            this.resetFlag = false;

            this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
            this.$api.sysUser.selectUserBySearch(
                Object.assign({}, this.searchData, this.options)
            ).then(data => {
                this.loading = false;
                if (data.data) {
                    this.desserts = data.data;
                    this.totalDesserts = data.total;
                } else {
                    this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                }

            })
            /*let data = Mock.mock({
              'data|10': [
                {
                  'id': '@guid',
                  'username': '@word(8, 12)',
                  'realname': '@cname',
                  'phone': /^1[385][1-9]\d{8}/,
                  'email':'@email',
                  'lastLoginTime':'@date("yyyy-MM-dd HH:mm:ss")',
                  'lenable|1': true,
                  'work|1':true,
                }
              ]
            });*/

        },
        changeOptions(option) {
            this.initialize()
        },
        isEnable(item) {
            let icon = 'mdi-check-circle';
            let color = 'success';
            let text = this.$vuetify.lang.t('$vuetify.custom.enable')
            if (item.lenable) {
                icon = 'mdi-close-circle';
                color = 'error';
                text = this.$vuetify.lang.t('$vuetify.custom.disable')
            }
            return {
                icon: icon,
                color: color,
                text: text
            }
        },
        isWork(item) {
            let icon = 'mdi-check-circle';
            let color = 'success';
            let text = this.$vuetify.lang.t('$vuetify.custom.user.work')
            if (item.work) {
                icon = 'mdi-close-circle';
                color = 'error';
                text = this.$vuetify.lang.t('$vuetify.custom.user.notWork')
            }
            return {
                icon: icon,
                color: color,
                text: text
            }
        },
        deleteBtn() {
            if (this.selected.length == 0) {
                this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.pleaseSelectDelete'))
            } else {
                const ids = [];
                for (let i = 0; i < this.selected.length; i++) {
                    ids.push(this.selected[i].id)
                }
                this.$dialog.confirm(this.$vuetify.lang.t('$vuetify.custom.deleteNow'), null, () => {
                    this.$api.sysUser.deleteUser({id: ids.toString()}).then(data => {
                        this.initialize()
                    })
                })
            }
        },
        deleteItem(item) {
            const id = item.id;
            this.$dialog.confirm(this.$vuetify.lang.t('$vuetify.custom.deleteSelect'), null, () => {
                this.$api.sysUser.deleteUser({id: id}).then(data => {
                    this.initialize()
                })
            })
        },
        work(item) {
            this.$api.sysUser.updateUserWork({
                id: item.id
            }).then(data => {
                if (data.flag) {
                    this.initialize()
                }
            })
        },
        lenable(item) {
            this.resetPasswordDialog = true;
            this.resetUserName = item.username;
            this.checkPassword = true;
            this.userId = item.id;

        },
        reset(item) {
            this.resetPasswordDialog = true;
            this.resetUserName = item.username;
            this.resetFlag = true;
        },
        modPassword(item) {
            this.resetPasswordDialog = true;
            this.resetUserName = item.username;
            this.updateFlag = true;
        },
    },
    components: {
        userAdd,
        userDetail,
        ETDatePicker,
        userPassword
    },
}
</script>
